import { ILessonNavigation } from '@/shared/types/lesson';
import { LessonNavCard } from './LessonNavCard';

interface LessonPagerProps {
  lessons: ILessonNavigation[];
  currentLessonOrder: number;
  buildLessonLink: (lesson: ILessonNavigation) => string;
}

export function LessonPager({ lessons, currentLessonOrder, buildLessonLink }: LessonPagerProps) {
  const getPrevNextLessons = (lessons: ILessonNavigation[], currentLessonOrder: number) => {
    const sorted = [...lessons].sort((a, b) => a.order - b.order);

    const idx = sorted.findIndex((l) => l.order === currentLessonOrder);
    if (idx === -1) return { prev: null, next: null, sorted };

    return {
      prev: sorted[idx - 1] ?? null,
      next: sorted[idx + 1] ?? null,
      sorted,
    };
  };
  const { prev, next } = getPrevNextLessons(lessons, currentLessonOrder);

  const prevTo = prev ? buildLessonLink(prev) : null;
  const nextTo = next ? buildLessonLink(next) : null;

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
      <LessonNavCard direction="prev" lesson={prev} to={prevTo} />
      <LessonNavCard direction="next" lesson={next} to={nextTo} />
    </div>
  );
}
